import { render, staticRenderFns } from "./report-view-report4.vue?vue&type=template&id=3fa4cdfa&"
import script from "./report-view-report4.vue?vue&type=script&lang=js&"
export * from "./report-view-report4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports